import { render } from "./OneOnOneList.vue?vue&type=template&id=4ef01930&scoped=true"
import script from "./OneOnOneList.vue?vue&type=script&lang=js"
export * from "./OneOnOneList.vue?vue&type=script&lang=js"

import "./OneOnOneList.vue?vue&type=style&index=0&id=4ef01930&lang=scss&scoped=true"
import "./OneOnOneList.vue?vue&type=style&index=1&id=4ef01930&lang=scss"
script.render = render
script.__scopeId = "data-v-4ef01930"

export default script